export const reportEmbedHeight = () => {
    if (window.parent == window) {
        return;
    }

    const cookieOverlayWrapper = document.getElementById('ps-cookie-banner-wrapper');

    const reportHeight = () => {
        const cookieBannerElement = document.getElementById('ps-cookie-banner');
        const cookieBannerHeight = cookieBannerElement
            ? cookieBannerElement.children[0].children[0].clientHeight + 20
            : 0;
        const bodyHeight = document.body.clientHeight;

        window.parent.postMessage(
            { height: bodyHeight < cookieBannerHeight ? cookieBannerHeight : bodyHeight },
            '*',
        );
    };

    const mutationObserver = new MutationObserver(reportHeight);
    const resizeObserver = new ResizeObserver(reportHeight);

    resizeObserver.observe(document.body);

    if (cookieOverlayWrapper) {
        mutationObserver.observe(cookieOverlayWrapper, { childList: true });
    }
};
